import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslations } from 'js/hooks/i18n';
import React, { useEffect, useState } from 'react';
import { Loader } from 'js/components/common/Loader';
import { WebContent } from 'js/components/system/WebContent';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { useNotificationSubscriptions } from 'js/components/system/App/components/AppPostInit/hooks';

import { GameIFrame } from './components/GameIFrame';
import { WrapperHelmet } from './components/WrapperHelmet';
import { useGetLauncherUrl } from './hooks/useGetLauncherUrl';

import style from './WrapperInner.scss';

export const WrapperInner = () => {
    const { search } = useLocation();
    const dispatch = useDispatch();
    const getLauncherUrl = useGetLauncherUrl();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const [gameLaunchUrl, setGameLaunchUrl] = useState('');
    const searchParams = new URLSearchParams(search);
    const t = useTranslations('playtech.mobile.system.launcher.gameUnavailablePopup.');
    const title = searchParams.get('gameName');
    const { wrapperHeaderWebContentId, wrapperFooterWebContentId } = useAppSelector(
        pick(['wrapperHeaderWebContentId', 'wrapperFooterWebContentId']));

    useNotificationSubscriptions();

    useEffect(() => {
        (async () => {
            try {
                const launcherUrl = await getLauncherUrl();

                setGameLaunchUrl(launcherUrl);
            } catch {
                dispatch(showCommonPopupAction({
                    title: `${title} ${t('title')}`,
                    content: t(isDesktop ? 'desktop-content' : 'mobile-content'),
                    onClose: () => window.close()
                }));
            }
        })();
    }, [isDesktop, title, t, dispatch, setGameLaunchUrl, getLauncherUrl]);

    return (
        <>
            <WrapperHelmet title={title} />
            {wrapperHeaderWebContentId && <WebContent id={wrapperHeaderWebContentId} />}
            {!gameLaunchUrl && (<Loader className={style.loader} />)}
            {gameLaunchUrl && (<GameIFrame src={gameLaunchUrl} />)}
            {wrapperFooterWebContentId && <WebContent id={wrapperFooterWebContentId} />}
        </>
    );
};
